import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

// Send auth cookies on every API request
axios.defaults.withCredentials = true;

// API Service for Simplified Helpdesk
export const api = {
  // Dashboard/Stats
  getDashboardStats: async () => {
    const response = await axios.get(`${API_BASE}/dashboard/stats`);
    return response.data;
  },

  getAIInsights: async () => {
    const response = await axios.get(`${API_BASE}/dashboard/ai-insights`);
    return response.data;
  },

  // Tickets
  getTickets: async (companyId = null, status = null) => {
    let url = `${API_BASE}/tickets`;
    const params = new URLSearchParams();
    if (companyId) params.append('company_id', companyId);
    if (status) params.append('status', status);
    
    if (params.toString()) {
      url += `?${params.toString()}`;
    }
    
    const response = await axios.get(url);
    return response.data;
  },

  getTicket: async (ticketId) => {
    const response = await axios.get(`${API_BASE}/tickets/${ticketId}`);
    return response.data;
  },

  createTicket: async (ticketData) => {
    const response = await axios.post(`${API_BASE}/tickets`, ticketData);
    return response.data;
  },

  updateTicket: async (ticketId, updates) => {
    const response = await axios.put(`${API_BASE}/tickets/${ticketId}`, updates);
    return response.data;
  },

  deleteTicket: async (ticketId) => {
    const response = await axios.delete(`${API_BASE}/tickets/${ticketId}`);
    return response.data;
  },

  // Company
  getCompany: async (companyId) => {
    const response = await axios.get(`${API_BASE}/companies/${companyId}`);
    return response.data;
  },

  createCompany: async (companyData) => {
    const response = await axios.post(`${API_BASE}/companies`, companyData);
    return response.data;
  },

  getCompanyStats: async (companyId) => {
    const response = await axios.get(`${API_BASE}/companies/${companyId}/stats`);
    return response.data;
  },

  // T2 Feedback
  registerT2Feedback: async (companyId) => {
    const response = await axios.post(`${API_BASE}/t2-feedback/register?company_id=${companyId}`);
    return response.data;
  },

  getT2Feedback: async (companyId) => {
    const response = await axios.get(`${API_BASE}/t2-feedback/${companyId}`);
    return response.data;
  },

  submitT2Feedback: async (feedbackId, feedback) => {
    const response = await axios.post(`${API_BASE}/t2-feedback/${feedbackId}/submit`, feedback);
    return response.data;
  }
};

export default api;
